import { render, staticRenderFns } from "./user-select.vue?vue&type=template&id=3874c8e3&lang=pug"
import script from "./user-select.vue?vue&type=script&lang=js"
export * from "./user-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports